// Module
var code = `<div class="js-input-numeric-with-button-container">
    <terceraNumeric enabled="{{enabled}}" minValue="{{minValue}}" maxValue="{{maxValue}}" step="{{step}}" decimalPrecision="{{decimalPrecision}}" value="{{value}}"/>
    <terceraButton name="refreshButton" terceraButtonStyle="js-button-refresh-standard" SVG="true" on-btnClick="onRefreshButtonClick" />
</div>`;
// Exports
export default code;